/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'

const mdSize = {height: 14, borderRadius: 'base'}

export default {
    sizes: {
        md: {
            field: {...mdSize, px: 2},
            addon: mdSize
        }
    },
    baseStyle: {
        field: {
            _focus: {
                borderColor: 'blue.600'
            },
            '::-webkit-date-and-time-value': {
                textAlign: 'start'
            }
        },
        _placeholder: {
            color: 'stokkeGray.accessibleText'
        }
    },
    variants: {
        filled: {
            // we use filled variant for
            // search input
            field: {
                backgroundColor: 'gray.50',
                _focus: {
                    backgroundColor: 'white'
                },
                _hover: {
                    backgroundColor: 'gray.100',
                    _focus: {
                        backgroundColor: 'white'
                    }
                },
                _placeholder: {
                    color: 'stokkeGray.accessibleText'
                }
            }
        },
        flushed: {
            field: {
                // fix for placeholder - the size px is not applied when input is empty
                px: 2,
                bg: 'stokkeCore.white',
                borderBottom: '2px solid',
                borderColor: 'stokkeCore.black',
                color: 'stokkeCore.black',
                ...textStyles['Regular Medium'],
                _placeholder: {
                    color: 'stokkeGray.accessibleText'
                },
                _invalid: {
                    borderColor: 'stokkeFunctional.alertRed',
                    boxShadow: 'none',
                    color: 'stokkeFunctional.alertRed',
                    icon: {
                        color: 'stokkeFunctional.alertRed'
                    },
                    _focus: {
                        borderColor: 'stokkeFunctional.alertRed'
                    }
                },
                _focus: {
                    borderColor: 'stokkeCore.black',
                    boxShadow: 'none'
                },
                _focusVisible: {
                    boxShadow: 'none',
                    borderColor: 'stokkeCore.black'
                },
                _disabled: {
                    backgroundColor: 'stokkeGray.mid'
                }
            }
        },
        focused: {
            field: {
                _focus: {
                    boxShadow: 'outline'
                }
            }
        },
        accepted: {
            field: {
                borderBottom: '2px solid',
                borderRadius: 0,
                borderColor: 'stokkeFunctional.alertGreen',
                color: 'stokkeCore.black',
                ...textStyles['Regular Medium'],
                _focus: {
                    borderColor: 'stokkeFunctional.alertGreen'
                }
            }
        }
    }
}
